import store from '@/store'
import ModuleBase from '@/modules/inquiries/components/ModuleBase'
import InquiryBase from '@/modules/inquiries/views/detail/InquiryBase'
import InquiriesDashboard from '@/modules/inquiries/views/Dashboard'
import SoldAndArchivedInquiries from '@/modules/inquiries/views/SoldAndArchived'
import InquiryOverview from '@/modules/inquiries/views/detail/Overview'


const routes = [
  {
    path: '/inquiries/',
    component: ModuleBase,
    meta: { appKey: 'inquiries' },
    children: [
      {
        path: 'dashboard',
        component: InquiriesDashboard,
        name: 'InquiriesDashboard',
        beforeEnter: (to, from, next) => {
          store.dispatch('clearSubnav')
          next()
        }
      },
      {
        path: 'sold-and-archived',
        component: SoldAndArchivedInquiries,
        name: 'SoldAndArchivedInquiries'
      },
      {
        path: 'detail/:id/',
        component: InquiryBase,
        children: [
          {
            path: 'overview',
            name: 'InquiryOverview',
            component: InquiryOverview
          }
        ]
      }
    ]
  }
]

export default routes
